(async () => {
    const { Core } = await importModule('Core');
    const { parseHTML, $clone } = await importModule('Utils');

    const CN_EMPTY = '!empty';
    const EL_DRAWER_TRIGGER = 'cart-drawer-trigger';

   function defineTrigger() {
        if(!customElements.get(EL_DRAWER_TRIGGER)) {
            customElements.define(EL_DRAWER_TRIGGER, class extends Core {
                render() {
                    this.addEventListener('click', this._onClick.bind(this))        
                }
        
                _onClick(e) {
                    e.preventDefault();
                    this.publish('modal:open', {
                        stash: 'cart-drawer',
                        animation: 'slideRight',
                        position: 'center-right',
                        height: '100%',
                        width: 'min(30rem, 95vw)',
                        transition: '300'
                    });
                    setTimeout(() => { $('#Slider-ks-cart-upsells').slick('refresh'); }, 500);
                }
            })
        }
    }

    function selectItemByKey(key, src) {
        return src.querySelector(`[data-item-key="${key}"]`);
    }

    customElements.define('cart-drawer', class extends Core {
        subscriptions = {
            'modal:open':  '_close',
            'cart:update': '_update',
            'drawer:item-loading': '_itemLoading'
        }

        elements = {
            productLoadingTemplate: '[data-product-loading-template]',
            dynamicParts: '*[data-dynamic]'
        }

        async render() {
            await customElements.whenDefined('cart-provider');
            defineTrigger();
            this.publish('cart:add-feature', { feature: 'drawer' });
            this._handleEvents();
        }

        _handleEvents() {
            this.subscribe('cart:update', { global: true });
            this.subscribe('drawer:item-loading');
        }

        _itemLoading({ key }) {
            this.locked = true;
            const $upadtingItem = selectItemByKey(key, this);
            $upadtingItem
                ?.append($clone(this.$productLoadingTemplate))
        }
        
        async _update({ drawer, meta }) {
            console.log(drawer);
            console.log(meta);
            if (!drawer?.section) return; // sanity check from provider
            // Since drawer wrapped inside a template (as stash) we need to clone it
            this.$updatedDoc = parseHTML(drawer.section).querySelector('#cart-drawer-stash').content.cloneNode(true);
            this._updateDynamicParts();
            this._toggleEmpty(meta?.count);
            this.locked = false;
            if(drawer.open) {
                this._open();
            }
            console.log("Update Cart");
            this._cartGoal();
        }

        _cartGoal() {
            if(!document.querySelector("[data-total-price]"))  return;
            const subtotal = document.querySelector("[data-total-price]").getAttribute('data-total-price');
            
            console.log("buildCart"), console.log(subtotal);
            const ksCartGoal = document.querySelector("ks-cart-goal");
            if (!ksCartGoal) return;
            ksCartGoal.setAttribute("cart-total-price", subtotal);
            const data_goal_total = ksCartGoal.getAttribute("data-no-of-tiers"),
                data_goal_one_value = ksCartGoal.getAttribute("data-goal-one-value"),
                data_goal_two_value = ksCartGoal.getAttribute("data-goal-two-value"),
                data_goal_three_value = ksCartGoal.getAttribute("data-goal-three-value"),
                data_goal_one_desc = ksCartGoal.getAttribute("data-goal-one-desc"),
                data_goal_two_desc = ksCartGoal.getAttribute("data-goal-two-desc"),
                data_goal_three_desc = ksCartGoal.getAttribute("data-goal-three-desc"),
                data_goal_completed_desc = ksCartGoal.getAttribute("data-goal-completed-desc"),
                data_goal_two_diff = ksCartGoal.getAttribute("data-goal-two-diff"),
                data_goal_three_diff = ksCartGoal.getAttribute("data-goal-three-diff");

                var divider = 100;
                if(data_goal_three_diff > 0){
                    divider = 33.33;
                }else if(data_goal_two_diff > 0){
                    divider = 50;
                }
                console.log(divider);
            if (parseInt(subtotal) < parseInt(data_goal_one_value)) {
                console.log(111);
                var percentage = subtotal / (data_goal_one_value / 100) * divider / 100;
                var goal_remaining_money = Shopify.formatMoney(data_goal_one_value - subtotal),
                    goal_desc = data_goal_one_desc.replace("[amount]", goal_remaining_money),
                    goal_completed = 0;
                ksCartGoal.querySelector(".ks-cart-goal-icons .item-1") && ksCartGoal.querySelector(".ks-cart-goal-icons .item-1").classList.remove("active"), ksCartGoal.querySelector(".ks-cart-goal-icons .item-2") && ksCartGoal.querySelector(".ks-cart-goal-icons .item-2").classList.remove("active"), ksCartGoal.querySelector(".ks-cart-goal-icons .item-3") && ksCartGoal.querySelector(".ks-cart-goal-icons .item-3").classList.remove("active")
            } else if (parseInt(subtotal) < parseInt(data_goal_two_value)) {
                console.log(222);
                var percentage = ((subtotal - data_goal_one_value) / data_goal_two_diff * divider / 100 ) + 33.33;
                var goal_remaining_money = Shopify.formatMoney(data_goal_two_value - subtotal),
                    goal_desc = data_goal_two_desc.replace("[amount]", goal_remaining_money),
                    goal_completed = 1;
                ksCartGoal.querySelector(".ks-cart-goal-icons .item-1") && ksCartGoal.querySelector(".ks-cart-goal-icons .item-1").classList.add("active"), ksCartGoal.querySelector(".ks-cart-goal-icons .item-2") && ksCartGoal.querySelector(".ks-cart-goal-icons .item-2").classList.remove("active"), ksCartGoal.querySelector(".ks-cart-goal-icons .item-3") && ksCartGoal.querySelector(".ks-cart-goal-icons .item-3").classList.remove("active")
            } else if (parseInt(subtotal) < parseInt(data_goal_three_value)) {
                console.log(333);
                var percentage = ((subtotal - data_goal_two_value) / data_goal_three_diff * divider / 100 ) + 66.66;
                var goal_remaining_money = Shopify.formatMoney(data_goal_three_value - subtotal),
                    goal_desc = data_goal_three_desc.replace("[amount]", goal_remaining_money),
                    goal_completed = 2;
                ksCartGoal.querySelector(".ks-cart-goal-icons .item-1") && ksCartGoal.querySelector(".ks-cart-goal-icons .item-1").classList.add("active"), ksCartGoal.querySelector(".ks-cart-goal-icons .item-2") && ksCartGoal.querySelector(".ks-cart-goal-icons .item-2").classList.add("active"), ksCartGoal.querySelector(".ks-cart-goal-icons .item-3") && ksCartGoal.querySelector(".ks-cart-goal-icons .item-3").classList.remove("active")
            } else {
                var percentage = 100,
                    goal_desc = data_goal_completed_desc,
                    goal_completed = 3;
                ksCartGoal.querySelector(".ks-cart-goal-icons .item-1") && ksCartGoal.querySelector(".ks-cart-goal-icons .item-1").classList.add("active"), ksCartGoal.querySelector(".ks-cart-goal-icons .item-2") && ksCartGoal.querySelector(".ks-cart-goal-icons .item-2").classList.add("active"), ksCartGoal.querySelector(".ks-cart-goal-icons .item-3") && ksCartGoal.querySelector(".ks-cart-goal-icons .item-3").classList.add("active")
            }
            console.log(data_goal_total), console.log(goal_completed), ksCartGoal.setAttribute("data-goal-completed", goal_completed), ksCartGoal.querySelector(".description").innerHTML = goal_desc;
            var progressBar = ksCartGoal.querySelector(".bs-progress-bar");
            const loadConfetti = () => {
                console.log("loadConfetti");
                /*
                confetti({
                    startVelocity: 30,
                    particleCount: 400,
                    spread: 90,
                    zIndex: 99999,
                    origin: {
                        x: .9,
                        y: 0
                    }
                })
                    */
                   const myCanvas = document.createElement('canvas')
                    myCanvas.setAttribute('id', 'ks-cart-goal-confetti-canvas')
                console.log(myCanvas);
                    if (document.querySelector('.cart-drawer')) {
                    document.querySelector('.cart-drawer').querySelector('.cart-drawer-header').insertAdjacentElement('afterbegin', myCanvas)
                    }

                    const myConfetti = window.confetti.create(myCanvas)

                    myConfetti({
                    particleCount: 400,
                    spread: 90
                    })

                    setTimeout(() => {
                    myCanvas.remove()
                    }, 4000)
            };
            progressBar.style.width = percentage + "%", setTimeout(() => {
                percentage == 100 && loadConfetti()
            }, 200)
        }
        
        _updateDynamicParts() {
            const parts = Array.from(this.$updatedDoc.querySelectorAll(this.elements.dynamicParts));
            parts.map(part => {
                const match = this.$dynamicParts.find(item => item.dataset.dynamic === part.dataset.dynamic);
                match.replaceChildren(...part.childNodes);
            })
        }

        _toggleEmpty(count) {
            this.classList.toggle(CN_EMPTY, !count);
        }
        
        _open() {
            this.publish('modal:open', {
                stash: 'cart-drawer',
                animation: 'slideRight',
                position: 'center-right',
                height: '100%',
                width: 'min(30rem, 95vw)',
                transition: '300'
            });
        }

        set locked(state) {
            this.classList.toggle('!loading', state);
            window.modalLock = state;
        }
    })

    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_SELLING_PLAN_ID = 'selling-plan-id';
    const ATTR_ITEM_KEY = 'key';
    
    customElements.define('cart-drawer-qty-button', class extends Core {
        render() {
            this.addEventListener('click', this._handleClick.bind(this), { once: true });
        }

        _handleClick() {
            this.publish('cart:change', {
                id: this.variantId,
                key: this.key,
                quantity: this.value,
                selling_plan: this.sellingPlanId,
                src: 'drawer'
            });
            
            this.publish('drawer:item-loading', {
                key: this.key
            })
        }

        disconnect() {
            this.removeEventListener('click', this._handleClick.bind(this), false);
        }

        get variantId() {
            return this.getAttribute(ATTR_VARIANT_ID);
        }

        get sellingPlanId() {
            return this.getAttribute(ATTR_SELLING_PLAN_ID) || '';
        }

        get value() {
            return this.getAttribute('set-value');
        }

        get key() {
            return this.getAttribute(ATTR_ITEM_KEY);
        }
    });
})();